
import pdfobject from 'pdfobject';
import { defineComponent, ref, onMounted, watch, nextTick } from 'vue';

export default defineComponent({
  props: {
    fileUrl: String,
  },
  emits: ['viewerCreated', 'loaded'],
  setup(props, context) {
    const pdfDiv = ref(null);

    onMounted(() => {
      loadFile();

      context.emit('viewerCreated');
    });

    const loadFile = () => {
      if (!props.fileUrl) {
        return;
      }
      const options = {
        pdfOpenParams: {
          navpanes: 0,
          toolbar: 0,
          statusbar: 0,
          view: 'FitV',
          pagemode: 'none',
          page: 1,
        },
        forcePDFJS: true,
        PDFJS_URL: '/pdfjs/web/viewer.html',
      };
      nextTick(() => {
        if (!props.fileUrl) {
          return;
        }
        const myPDF = pdfobject.embed(props.fileUrl, pdfDiv.value, options);

        context.emit('loaded');
        if (!myPDF)
          console.error('PDFObject creation failed');
      });

    };

    watch(() => props.fileUrl, loadFile);

    return { pdfDiv };
  },
});
